module.exports = __webpack_public_path__ + "img/kanbantagedit.58253277.svg";